import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/homeData';

function SiteNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-all duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="flex items-center justify-between gap-4 px-4 md:px-8 h-16">
        <a href="#top" className="flex items-center gap-2 shrink-0">
          <span
            className={`flex items-center justify-center w-9 h-9 rounded-md text-lg transition-colors ${
              solid ? 'bg-primary-500 text-background-50' : 'bg-background-50/90 text-primary-600'
            }`}
          >
            <i className="ri-newspaper-line" />
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-wide transition-colors ${
              solid ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            黑料网社
          </span>
        </a>

        <nav className="hidden md:flex items-center justify-center gap-1 flex-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3 py-2 text-sm font-label rounded-md whitespace-nowrap transition-colors ${
                solid
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <label
            className={`hidden lg:flex items-center gap-2 h-9 px-3 rounded-md border transition-colors ${
              solid
                ? 'border-background-300 bg-background-100 text-foreground-500'
                : 'border-white/30 bg-white/10 text-background-50/80'
            }`}
          >
            <i className="ri-search-line text-sm" />
            <input
              type="text"
              placeholder="搜索分区 / 频道"
              className={`w-40 bg-transparent text-sm outline-none font-label placeholder:font-label ${
                solid ? 'text-foreground-900' : 'text-background-50 placeholder:text-background-50/70'
              }`}
            />
          </label>
          <a
            href="#districts"
            className="hidden sm:inline-flex items-center gap-1 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-compass-3-line" />
            开始逛
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden flex items-center justify-center w-9 h-9 rounded-md text-xl transition-colors ${
              solid ? 'text-foreground-900 hover:bg-background-100' : 'text-background-50 hover:bg-white/10'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
          <nav className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 text-sm font-label rounded-md bg-background-100 text-foreground-800 hover:bg-primary-50 hover:text-primary-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}

export default SiteNavbar;